import { UncontrolledAlert } from 'reactstrap';
import { useQuery } from '@tanstack/react-query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { Link } from '@s20/components/common/Link';
import { httpClient } from '@s20/services/httpClient';
import {
    ApiRoutes,
    AppNavPaths,
} from '../Common';

const getQuickJobAlertLink = (job) => (job?.projectId
    ? `${AppNavPaths.Project}/${job.projectId}?openJob=${job.id}`
    : `${AppNavPaths.Job}/${job.id}`);

const getQuickJobAlertLinkText = (job) => (job?.projectId ? 'View Project' : 'View Job');

export const QuickJobCreatedAlert = ({ jobId }) => {
    const parsedJobId = parseInt(jobId, 10);

    const { data } = useQuery({
        queryKey: ['quick-job-created-alert', parsedJobId],
        enabled: Number.isInteger(parsedJobId) && parsedJobId > 0,
        queryFn: async () => {
            const response = await httpClient.js(ApiRoutes.job.byId(parsedJobId));
            return response?.job ?? null;
        },
    });

    if (!data?.id) {
        return null;
    }

    return (
        <UncontrolledAlert color="success">
            <div
                className="d-flex align-items-start"
                style={{ minWidth: 0 }}
            >
                <FontAwesomeIcon
                    icon={faCircleCheck}
                    className="mr-3 mt-1 flex-shrink-0"
                />

                <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center flex-grow-1">
                    <span className="mb-0 mr-sm-2">
                        <b>
                            Job
                            {' '}
                            #
                            {data.jobNumber || data.id}
                        </b>
                        {' '}
                        created successfully.
                    </span>

                    <Link
                        to={getQuickJobAlertLink(data)}
                        className="font-weight-bold alert-success text-nowrap mt-1 mt-sm-0"
                        target="blank"
                    >
                        {getQuickJobAlertLinkText(data)}
                    </Link>
                </div>
            </div>
        </UncontrolledAlert>
    );
};
